import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { format } from 'date-fns';
import { RecruitmentPeriod } from '../../../../domain/myShift';

/**
 * 募集期間表示コンポーネントのProps
 */
interface RecruitmentPeriodDisplayProps {
  /** 募集期間データ（null の場合は非表示または取得中） */
  period: RecruitmentPeriod | null;
  /** エラーメッセージ（取得失敗時に「取得できませんでした」を表示） */
  error?: string;
}

/**
 * 日付フォーマット処理
 * @param isoDate - ISO 8601形式の日付文字列
 * @returns yyyy/MM/dd HH:mm 形式の文字列
 */
const formatRecruitmentDate = (isoDate: string): string => {
  return format(new Date(isoDate), 'yyyy/MM/dd HH:mm');
};

/**
 * 募集期間表示コンポーネント
 */
export const RecruitmentPeriodDisplay: React.FC<RecruitmentPeriodDisplayProps> = ({
  period,
  error,
}) => {
  // エラー時の表示
  if (error) {
    return (
      <Paper
        variant="outlined"
        sx={{
          p: 2,
          mb: 2,
          backgroundColor: '#fff1da',
          borderColor: '#e9d5b4',
        }}
      >
        <Typography variant="body2" color="warning.dark">
          募集期間: {error}
        </Typography>
      </Paper>
    );
  }

  // データがない場合は非表示
  if (!period) {
    return null;
  }

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        mb: 2,
        backgroundColor: '#fff',
        borderColor: '#dedbd7',
      }}
    >
      <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
        <Box>
          <Typography variant="caption" color="text.secondary">
            募集開始日
          </Typography>
          <Typography variant="body1" fontWeight="medium">
            {formatRecruitmentDate(period.startDate)}
          </Typography>
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">
            募集終了日
          </Typography>
          <Typography variant="body1" fontWeight="medium">
            {formatRecruitmentDate(period.endDate)}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default RecruitmentPeriodDisplay;
